<div class="p-2">
    <div>
        <div class="d-inline-flex align-items-center">
            <h5 class="m-0"><b>Add Event</b></h5>
        </div>

        <div class="mt-2">
            <!-- <kendo-label [text]="'Location Type'"
                         [ngClass]="selectedLocationType() ? 'text-grey' : 'text-red'">
                <kendo-combobox [data]="locationTypeDropdown"
                                [(value)]="selectedLocationType"
                                [valuePrimitive]="true"
                                [clearButton]="false"
                                [fillMode]="'outline'"
                                placeholder="Select location type"
                                [popupSettings]="{ width: 'auto'}"
                                [virtual]="true"
                                [class.border-red]="!selectedLocationType()">
                </kendo-combobox>
            </kendo-label> -->
            <kendo-label [text]="'Terminal / Anchorage Area / Pilot Station'"
                         [ngClass]="selectedTerminal() ? 'text-grey' : 'text-red'">
                <kendo-combobox [data]="terminalsDropdown()"
                                [(value)]="selectedTerminal"
                                (valueChange)="onTerminalChange()"
                                [valuePrimitive]="false"
                                [valueField]="'id'"
                                [textField]="'name'"
                                [clearButton]="false"
                                [fillMode]="'outline'"
                                placeholder="Select location"
                                [popupSettings]="{ width: 'auto'}"
                                [virtual]="true"
                                [class.border-red]="!selectedTerminal()">
                </kendo-combobox>
            </kendo-label>
            <kendo-label [text]="'Berth / Anchorage'"
                         class="text-grey">
                <kendo-combobox [data]="berthDropdown()"
                                [(value)]="selectedBerth"
                                [valuePrimitive]="false"
                                [valueField]="'id'"
                                [textField]="'name'"
                                [clearButton]="false"
                                [fillMode]="'outline'"
                                placeholder="Select location"
                                [popupSettings]="{ width: 'auto'}"
                                [virtual]="true">
                </kendo-combobox>
            </kendo-label>
        </div>
        <div class="row no-gutters mt-1"
             style="gap:12px;">
            <div class="col">
                <kendo-label text="ETA"
                             [ngClass]="startTimeIsInvalid() ? 'text-red' : 'text-grey'">
                    <kendo-datetimepicker [value]="startTime()"
                                          [class.border-red]="startTimeIsInvalid()"
                                          placeholder="ETA"
                                          [fillMode]="'outline'"
                                          (valueChange)="startTime.set($event)"></kendo-datetimepicker>
                </kendo-label>
            </div>
            <div class="col">
                <kendo-label text="ETD"
                             [ngClass]="endTimeIsInvalid() ? 'text-red' : 'text-grey'">
                    <kendo-datetimepicker placeholder="ETD"
                                          [class.border-red]="endTimeIsInvalid()"
                                          [value]="endTime()"
                                          [fillMode]="'outline'"
                                          (valueChange)="endTime.set($event)"></kendo-datetimepicker>
                </kendo-label>
            </div>
        </div>
        <div class="mt-2">
            <button kendoButton
                    class="w-100"
                    [disabled]="addEventDisabled()"
                    (click)="onAddMovement()"
                    [themeColor]="'primary'">Add Event</button>
        </div>
    </div>
</div>